import './PeriscopePaginatedList.scss';
import { PeriscopeList, PeriscopePagination } from '.';
import React, { useRef } from 'react';
export const PeriscopePaginatedList = ({ list, loading, onChange, queryParams, resource, title }) => {
    var _a, _b;
    const scrollableListRef = useRef(null);
    const totalCount = (_a = resource === null || resource === void 0 ? void 0 : resource.totalCount) !== null && _a !== void 0 ? _a : 0;
    const results = (_b = resource === null || resource === void 0 ? void 0 : resource.results) !== null && _b !== void 0 ? _b : [];
    return (React.createElement(React.Fragment, null,
        title && React.createElement("div", { className: 'periscope-list-title' }, title),
        React.createElement(PeriscopeList, { list: list, loading: loading, ref: scrollableListRef, results: results }),
        React.createElement(PeriscopePagination, { loading: loading, onChange: onChange, queryParams: queryParams, scrollRef: scrollableListRef, totalCount: totalCount })));
};
